import React from "react";
import Image from "next/image";
import styles from "./ServiceList.module.css";

interface ServiceItem {
  name: string;
  icon?: string;
  iconAlt?: string;
}

interface ServiceListProps {
  services: ServiceItem[];
  className?: string;
}

export default function ServiceList({ services, className = "" }: ServiceListProps) {
  return (
    <div className={`${styles['service-list']} ${className}`}>
      {services.map((service, index) => (
        <span key={index} className={styles['service-item']}>
          {service.icon && (
            <Image
              src={service.icon}
              alt={service.iconAlt || "Service icon"}
              className={styles['dot-black']}
              width={6}
              height={6}
            />
          )}
          {service.name}
        </span>
      ))}
    </div>
  );
}
